import { useModal } from 'vue-final-modal';
import ConfirmDeleteModal from '@/shared/ui/modals/ConfirmDeleteModal.vue';
import type { FormElement } from '../model/form.types';
import { useFormBuilderStore } from '../model/form-builder.store';
import { useFormRulesStore } from '../model/form-rules.store';

export function useRuleAwareElementDeletion() {
  const formBuilderStore = useFormBuilderStore();
  const formRulesStore = useFormRulesStore();

  function requestRuleAwareDeletion(
    elements: FormElement | readonly FormElement[],
    onConfirm: () => void
  ): boolean {
    if (formRulesStore.rules.length === 0) {
      formRulesStore.loadPersistedRules();
    }

    const elementsToDelete = Array.isArray(elements) ? elements : [elements];
    if (
      elementsToDelete.length === 0 ||
      !elementsToDelete.some((element) => formRulesStore.hasRuleAssociatedWithElement(element))
    ) {
      return false;
    }

    const { open, close } = useModal({
      component: ConfirmDeleteModal,
      attrs: {
        title: 'O elemento tem regras aplicadas.\nTem certeza que deseja deletar?',
        description: 'A ação não pode ser desfeita e as edições feitas serão perdidas.',
        onClose() {
          close();
        },
        onConfirm() {
          close();
          onConfirm();
          formRulesStore.reconcileRulesWithElements(formBuilderStore.elements);
        },
      },
    });

    open();
    return true;
  }

  return {
    requestRuleAwareDeletion,
  };
}
